import { useEffect } from "react";

import { productDefault } from "./CreateProduct.const";
import ProductForm from "../../../components/templates/ProductForm";
import { FORM_STATE, MODE, useFormStore } from "../../../stores/formStore";

const CreateProduct = () => {
  const resetForm = useFormStore(state => state.reset);

  useEffect(() => {
    resetForm({ mode: MODE.EDIT, formState: FORM_STATE.NEW });
  }, [resetForm]);

  return <ProductForm formDefaultValues={productDefault} />;
};

export default CreateProduct;
